import createCrudModel, { CrudModel } from '../../common/crud-model/crud.model';
import Module from '../../types/module';

export type ModulesModel = CrudModel<Module>;
const modulesModel: ModulesModel = createCrudModel<Module>('/api/modules');

export default modulesModel;
